module.exports = __webpack_public_path__ + "img/cp5-7.761de347.jpg";